
interface AdNotification {
  id: string;
  type: 'ad_expiration' | 'ad_performance' | 'ad_approval' | 'ad_rejected';
  title: string;
  message: string;
  createdAt: Date;
  read: boolean;
  adId?: string;
}

// Add this type to handle general notifications
interface GeneralNotification {
  id: string;
  type: string;
  title: string;
  message: string;
  description: string;
  isRead: boolean;
  date: string;
  link?: string;
  userId: string;
}

class NotificationService {
  private adNotifications: AdNotification[] = [
    {
      id: '1',
      type: 'ad_expiration',
      title: 'Ad Expiring Soon',
      message: 'Your featured doctor ad will expire in 3 days.',
      createdAt: new Date(),
      read: false,
      adId: 'ad-123'
    },
    {
      id: '2',
      type: 'ad_performance',
      title: 'Low Ad Performance',
      message: 'Your homepage banner ad is performing below average.',
      createdAt: new Date(),
      read: false,
      adId: 'ad-456'
    },
    {
      id: '3',
      type: 'ad_expiration',
      title: 'Ad Expired',
      message: 'Your clinic promotion ad has expired.',
      createdAt: new Date(),
      read: false,
      adId: 'ad-789'
    }
  ];
  
  // New general notifications storage
  private generalNotifications: Record<string, GeneralNotification[]> = {};
  
  getAdNotifications(): AdNotification[] {
    return this.adNotifications;
  }
  
  markAsRead(id: string): boolean {
    this.adNotifications = this.adNotifications.map(notification => 
      notification.id === id ? { ...notification, read: true } : notification
    );
    return true;
  }

  // Add the missing functions
  getNotifications(userId: string): Promise<any[]> {
    // Return existing notifications for this user or empty array
    return Promise.resolve(this.generalNotifications[userId] || []);
  }

  markAllAsRead(userId: string): Promise<boolean> {
    if (this.generalNotifications[userId]) {
      this.generalNotifications[userId] = this.generalNotifications[userId].map(
        notification => ({ ...notification, isRead: true })
      );
    }
    return Promise.resolve(true);
  }

  createNotification(userId: string, notification: {
    title: string;
    message: string;
    type: string;
    link?: string;
  }): Promise<any> {
    const newNotification = {
      id: `${Date.now()}`,
      ...notification,
      description: notification.message,
      isRead: false,
      date: new Date().toISOString(),
      userId
    };

    if (!this.generalNotifications[userId]) {
      this.generalNotifications[userId] = [];
    }

    this.generalNotifications[userId].unshift(newNotification);
    return Promise.resolve(newNotification);
  }
  
  // Functions needed for chat service
  addChatMessageNotification(receiverId: string, senderId: string, message: string): void {
    this.createNotification(receiverId, {
      title: `New message from ${senderId}`,
      message,
      type: 'new_chat_message'
    });
  }
  
  showMessageNotification(senderName: string, message: string, link: string): void {
    console.log(`Notification: ${senderName} - ${message} - ${link}`);
    // This is just a mock function for now
  }
}

export const notificationService = new NotificationService();

// Export the notification functions directly so they can be imported elsewhere
export const addChatMessageNotification = (receiverId: string, senderId: string, message: string) => {
  return notificationService.addChatMessageNotification(receiverId, senderId, message);
};

export const showMessageNotification = (senderName: string, message: string, link: string) => {
  return notificationService.showMessageNotification(senderName, message, link);
};
